import { AUTH_PREFIX } from './api-client';

/** Cliente mínimo do better-auth: só e-mail/senha, que é o único método habilitado. */
export async function signIn(email: string, password: string): Promise<void> {
  const response = await fetch(`${AUTH_PREFIX}/sign-in/email`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password }),
  });

  if (!response.ok) {
    const body = (await response.json().catch(() => null)) as { message?: string } | null;
    throw new Error(body?.message ?? 'E-mail ou senha inválidos.');
  }
}

export async function signOut(): Promise<void> {
  await fetch(`${AUTH_PREFIX}/sign-out`, { method: 'POST', credentials: 'include' });
  window.location.assign('/login');
}
